<template>
    <p><a href="http://www.en.arivotyre.com/" target="_self" v-on:click="toEnglish">EN</a>丨<a href="http://www.es.arivotyre.com/" target="_self" v-on:click="toSpanish">español</a>丨<a
                href="http://www.ru.arivotyre.com/" target="_self" v-on:click="toRussian">Русский язык</a> </p>
                <!-- | <a href="/" v-on:click="toChinese" target="_self">中文</a> -->
</template>
<script>
import VueCookies from 'vue-cookies'
import Consts from '../../consts'
export default {
    name: 'Language',
    methods: {
        toChinese: function(){
            VueCookies.set(Consts.COOKIE_LANG, 'en')
        },
        toEnglish: function(){
            VueCookies.set(Consts.COOKIE_LANG, 'en')
        },
        toSpanish: function(){
            VueCookies.set(Consts.COOKIE_LANG, 'es')            
        },
        toRussian: function(){
            VueCookies.set(Consts.COOKIE_LANG, 'ru')
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/common/language.vue